export default __webpack_public_path__ + "static/media/2-way-icon-2.c549b94a.png";